import Festivals from "../../components/Nursery/GeneralAwareness/Festivals";
import MyHome from "../../components/Nursery/GeneralAwareness/MyHome";
import MyHomeMenu from "./MyHome";
import FestivalsMenu from "./Festivals";
import Colors from "../../components/Nursery/GeneralAwareness/Colors";
import ColorsMenu from "./Colors";
import DayWeekMonth from "../../components/Nursery/GeneralAwareness/DayWeekMonth";
import DayWeekMonthMenu from "./DayWeekMonth";
import CommunityHelpers from "../../components/Nursery/GeneralAwareness/CommunityHelpers";
import CommunityHelpersMenu from "./CommunityHelpers";
import TransportMode from "../../components/Nursery/GeneralAwareness/TransportMode";
import TransportModeMenu from "./TransportMode";
import NeighbourhoodArea from "../../components/Nursery/GeneralAwareness/NeighbourhoodArea";
import NeighbourhoodAreaMenu from "./NeighbourhoodArea";
import GoodBadHabbit from "../../components/Nursery/GeneralAwareness/GoodBadHabbit";
import GoodBadHabbitMenu from "./GoodBadHabbit";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    // { url: "/nursery/general-awareness/me-my-family ", title: "Me & My Family"},
    { url: "/nursery/general-awareness/my-home", title: "My home", component: MyHome, subMenu: MyHomeMenu},
    { url: "/nursery/general-awareness/festivals", title: "Identify Festivals", component: Festivals, subMenu: FestivalsMenu},
    { url: "/nursery/general-awareness/colors", title: "Identify Colors", component: Colors, subMenu: ColorsMenu},
    { url: "/nursery/general-awareness/days-week-month", title: "Days, Week & Month", component: DayWeekMonth, subMenu: DayWeekMonthMenu},
    { url: "/nursery/general-awareness/people-help-us", title: "People Who Help Us", component: CommunityHelpers, subMenu: CommunityHelpersMenu},
    { url: "/nursery/general-awareness/neighbourhood-area", title: "Neighbourhood Area", component: NeighbourhoodArea, subMenu: NeighbourhoodAreaMenu},
    { url: "/nursery/general-awareness/transport-mode", title: "Mode of Transport", component: TransportMode, subMenu: TransportModeMenu},
    { url: "/nursery/general-awareness/good-bad-habbit", title: "Good Habbit & Bad Habbit", component: GoodBadHabbit, subMenu: GoodBadHabbitMenu},
];


export default topics;